import React from 'react';
import PropTypes from 'prop-types';
import Button from '../Button';
import styles from '../../styles/test/TestStyles.module.css';

/**
 * ReviewCompletion component for displaying the review completion screen
 */
const ReviewCompletion = ({ 
  remainingQuestions, 
  onRestartReview, 
  onBackToHome 
}) => {
  return (
    <div className={styles.container}>
      <h2 style={{ margin: '1rem 0', fontSize: '1.5rem', fontWeight: 'bold', textTransform: 'uppercase', textAlign: 'center' }}>
        ¡Repaso Completado!
      </h2>
      <div className={styles.completionCard}>
        <p>Has repasado todas las preguntas falladas.</p>
        <p>Preguntas restantes para repasar: {remainingQuestions}</p>
      </div>
      
      <div className={styles.actionButtons}>
        <div className={styles.actionButtonsInner}>
          <Button
            variant="primary"
            onClick={onRestartReview}
          >
            Repasar de nuevo
          </Button>
          <Button
            variant="secondary"
            onClick={onBackToHome}
          >
            Volver al inicio
          </Button>
        </div>
      </div>
    </div>
  );
};

ReviewCompletion.propTypes = {
  remainingQuestions: PropTypes.number.isRequired,
  onRestartReview: PropTypes.func.isRequired,
  onBackToHome: PropTypes.func.isRequired
};

export default ReviewCompletion;